'use client'

import { useMemo } from 'react'
import { HeroContentClient as BikeHeroContentClient } from '../../lp/bike-insurance/HeroContentClient'
import { SimpleBikeFlowModal } from '../../lp/bike-insurance/SimpleBikeFlowModal'
import { getBikeContinueInsuringJourney, getHeroContentViewModel } from '../../lp/bike-insurance/heroWidgetBehavior.mjs'
import { useBikeRegistrationFlow } from '../../lp/bike-insurance/useBikeRegistrationFlow'
import { COMPREHENSIVE_HERO_CONTENT } from './heroConfig'

interface HeroContentClientProps {
  journeyData?: any[]
  regexPatternsData: string[]
}

export const HeroContentClient = ({ journeyData = [], regexPatternsData }: HeroContentClientProps) => {
  const heroViewModel = useMemo(() => getHeroContentViewModel(COMPREHENSIVE_HERO_CONTENT), [])
  const continueInsuringJourney = useMemo(() => getBikeContinueInsuringJourney(journeyData), [journeyData])
  const registrationFlow = useBikeRegistrationFlow({
    ctaText: heroViewModel.widget.ctaText,
    isSemPage: false,
    regexPatternsData,
    segmentHeading: heroViewModel.heading,
  })

  const registrationFormProps = {
    ctaText: heroViewModel.widget.ctaText,
    disclaimer: heroViewModel.widget.disclaimer,
    heading: heroViewModel.widget.heading,
    inputPlaceholder: heroViewModel.widget.inputPlaceholder,
    isFetching: registrationFlow.isFetching,
    onBlur: registrationFlow.handleRegistrationNumberBlur,
    onChange: registrationFlow.handleRegistrationNumberChange,
    onSubmit: registrationFlow.fetchAndInvokeHandleSubmit,
    registrationError: registrationFlow.registrationError,
    regNumber: registrationFlow.regNumber,
    showError: registrationFlow.showError,
  }

  return (
    <>
      <BikeHeroContentClient
        continueInsuringAdditionalEventProperties={{
          funnel: 'entry',
          journey: continueInsuringJourney?.is_renewal ? 'fresh_bike' : 'bike',
          product: 'bike',
        }}
        continueInsuringJourney={continueInsuringJourney}
        continueInsuringSegmentEventProps={registrationFlow.continueInsuringSegmentEventProps}
        viewModel={heroViewModel}
        registrationFormProps={registrationFormProps}
        onNewBikeClick={registrationFlow.handleNewBikeClick}
      />
      <SimpleBikeFlowModal
        show={registrationFlow.showIllogicalFlowModal}
        regNo={registrationFlow.regNumber}
        errorCode={registrationFlow.proposalAPIResponse?.error_code}
        illogicalFlowData={registrationFlow.proposalAPIResponse?.error_context}
        product={registrationFlow.product}
        setProposalAPIResponse={registrationFlow.setProposalAPIResponse}
        setShowIllogicalFlowModal={registrationFlow.setShowIllogicalFlowModal}
        onClose={registrationFlow.resetIllogicalFlow}
        onEditRegistration={registrationFlow.resetIllogicalFlow}
      />
    </>
  )
}
